const { 
    update_button_visibility,
    clear_error,
    render_verify_error,
    register_verify_error_rederer,
    default_error_rederer
} = require('./page_transition.js');

const {
    input_empty,
    input_valid_youtube_url
} = require('./form_check_helper');

const nunjucks = require('nunjucks');

register_verify_error_rederer("verify-9c521e9b-4678-48ac-9e0f-2fa4ae1dc38f",default_error_rederer);
register_verify_error_rederer("verify-f086128d-d97c-403c-a61d-86ec703fa60e",default_error_rederer);
register_verify_error_rederer("verify-83c8d981-3561-4559-9972-09f1e3636c4b",default_error_rederer);
register_verify_error_rederer("verify-d419ee5b-ce21-4ba4-aada-ad3661e6a09d",default_error_rederer);
register_verify_error_rederer("verify-de931b12-3a7c-4a96-af0e-8f990b92d6ed",default_error_rederer);

const page4_verify=(application_context)=>{

    application_context.ary_verify_error ??= [];

    // check1
    let DOM_input_watch_url;
    DOM_input_watch_url = document.querySelector(`[data-page="4"] [name="watch_url"]`);
    if(DOM_input_watch_url === null) {
        return false;
    }
    if(input_empty(DOM_input_watch_url)){
        application_context.ary_verify_error.push({
            code:"verify-9c521e9b-4678-48ac-9e0f-2fa4ae1dc38f",
            data:{
                field_name:"watch_url",
                description:`提出作品動画URLを入力ください`
            }
        });
    } else {
        if(input_valid_youtube_url(DOM_input_watch_url,{validator:application_context.library.validator}) === false){
            application_context.ary_verify_error.push({
                code:"verify-9c521e9b-4678-48ac-9e0f-2fa4ae1dc38f",
                data:{
                    field_name:"watch_url",
                    description:`提出作品動画URLを正しく入力ください。`
                }
            });
        }
    }
    
    // check2
    let DOM_input_composer;
    DOM_input_composer = document.querySelector(`[data-page="4"] [name="composer"]`);
    if(DOM_input_composer === null) {
        return false;
    }
    if(input_empty(DOM_input_composer)){
        application_context.ary_verify_error.push({
            code:"verify-f086128d-d97c-403c-a61d-86ec703fa60e",
            data:{
                field_name:"composer",
                description:`作曲者(原語)を入力ください`
            }
        });
    }
    
    // check3
    let DOM_input_workname;
    DOM_input_workname = document.querySelector(`[data-page="4"] [name="workname"]`);
    if(DOM_input_workname === null) {
        return false;
    }
    if(input_empty(DOM_input_workname)){
        application_context.ary_verify_error.push({
            code:"verify-83c8d981-3561-4559-9972-09f1e3636c4b",
            data:{
                field_name:"workname",
                description:`作曲者(原語)を入力ください`
            }
        });
    }    


    // check4
    let DOM_input_title_original_language;
    DOM_input_title_original_language = document.querySelector(`[data-page="4"] [name="title_original_language"]`);
    if(DOM_input_title_original_language === null) {
        return false;
    }
    if(input_empty(DOM_input_title_original_language)){
        application_context.ary_verify_error.push({
            code:"verify-d419ee5b-ce21-4ba4-aada-ad3661e6a09d",
            data:{
                field_name:"title_original_language",
                description:`作曲者(原語)を入力ください`
            }
        });
    }
    
    // check5
    let DOM_input_title_local_language;
    DOM_input_title_local_language = document.querySelector(`[data-page="4"] [name="title_local_language"]`);
    if(DOM_input_title_local_language === null) {
        return false;
    }
    if(input_empty(DOM_input_title_local_language)){
        application_context.ary_verify_error.push({
            code:"verify-de931b12-3a7c-4a96-af0e-8f990b92d6ed",
            data:{
                field_name:"title_local_language",
                description:`作曲者(原語)を入力ください`
            }
        });
    }

    return (application_context.ary_verify_error.length === 0);
}

module.exports.page4_prev = (application_context)=>{
    let page;

    window.splide_instance.go("<");

    page = window.splide_instance.index;
    application_context.page = page;

    update_button_visibility(application_context);    
}


module.exports.page4_next = (application_context)=>{

    // 次に進むタイミングでベリファイエラーをリセットする。
    application_context.ary_verify_error.length=0;
    clear_error({page:4});

    if(page4_verify(application_context)){
        let page;

        window.splide_instance.go(">");

        page = window.splide_instance.index;
        application_context.page = page;
        if('once' in application_context.ary_page_transition[page]){
            application_context.ary_page_transition[page]['once'].call(null,application_context);
        }
        
        
        update_button_visibility(application_context);
    } else {
        for(let blob_verify_error of application_context.ary_verify_error){
            render_verify_error(blob_verify_error);
        }
    }

}
